import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: 'product',
      component: home,
      children: [
        {
          path: 'common/:id',
          name: 'common',
          component: resolve => require(['@/components/list/common.vue'], resolve)
        },
        {
          path: 'getSalesmans',
          name: 'getSalesmans',
          component: resolve => require(['@/components/list/getSalesmans.vue'], resolve)
        },
        {
          path: 'product',
          name: 'product',
          component: resolve => require(['@/components/list/product.vue'], resolve)
        },
        {
          path: 'getBranch',
          name: 'getBranch',
          component: resolve => require(['@/components/list/getBranch.vue'], resolve)
        },
        {
          path: 'getRoster',
          name: 'getRoster',
          component: resolve => require(['@/components/list/getRoster.vue'], resolve)
        },
        {
          path: 'productDetail/:id',
          name: 'productDetail',
          component: resolve => require(['@/components/productDetail.vue'], resolve)
        },
      ]
    },
    {path: '*', redirect: '/', hidden: true}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js